import DropDown from "views/DropDown";
import PropTypes from "prop-types";
import React from "react";
import LoadObject from "data/LoadObject";

const MocksetNavItem = ({mocksetLO, activeMockset}) => {
    if (mocksetLO.isPending()) {
        return <li className="navbar-text">Loading...</li>;
    }
    if (mocksetLO.hasError()) {
        return <li className="navbar-text" title="There was an error loading the mockset manifest.">Error!</li>;
    }
    const {mocksets} = mocksetLO.getRequiredValue();
    if (mocksets && mocksets.length > 0) {
        return <DropDown label={activeMockset || "Mocks"}
                         align="right">
            {mocksets.map(s =>
                <li key={s} className={s === activeMockset ? "active" : null}><a href={`?mock=${s}`}>{s}</a></li>
            )}
        </DropDown>;
    }
    return null;
};

MocksetNavItem.propTypes = {
    activeMockset: PropTypes.string,
    mocksetLO: PropTypes.instanceOf(LoadObject),
};

export default MocksetNavItem;



// WEBPACK FOOTER //
// ./app/views/dev/MocksetNavItem.js